import { render, staticRenderFns } from "./profile-views.vue?vue&type=template&id=bff80a6c&scoped=true"
import script from "./profile-views.vue?vue&type=script&lang=js"
export * from "./profile-views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff80a6c",
  null
  
)

export default component.exports